import React, { useState, useEffect } from "react";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { T } from "components/alove/Translator";
const MDInput = require("components/MDInput").default;
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { addNewPositionDO, updatePositionDO, getPositionsDO } from "utils/positionsUtils";
import { Position } from "models/content/Position";

interface AddEditPositionDialogProps {
    refresh?: () => void;
  position?: Position | null; // If present, edit mode
}

const AddEditPositionDialog: React.FC<AddEditPositionDialogProps> = ({ refresh, position }) => {
  const isEdit = Boolean(position);
  const [positionName, setPositionName] = useState(position?.positionName || "");
  const [img, setImg] = useState(position?.img || "");
  const [parentId, setParentId] = useState<number | null>(position?.parentId ?? null);
  const [positions, setPositions] = useState<Position[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getPositionsDO("content").then((res) => {
      setPositions(res || []);
    });
  }, []);

  // Prefill fields when editing
  useEffect(() => {
    setPositionName(position?.positionName || "");
    setImg(position?.img || "");
    setParentId(position?.parentId ?? null);
  }, [position]);



  const valid = positionName.trim().length > 0;

  const handleConfirm = async () => {
    setLoading(true);
    setError("");
    try {
      if (isEdit && position) {
        await updatePositionDO(position.id, { positionName, img, parentId: parentId ?? undefined });
      } else {
        await addNewPositionDO({ positionName, img, parentId: parentId ?? undefined });
      }
      refresh?.();
    } catch (e) {
      setError("Failed to save position");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddNewPosition}
      dialogTitle={isEdit ? "Edit Position" : "Add New Position"}
      dialogConfirm={isEdit ? "Save" : "Add"}
      handleDismis={() => {}}
      handleConfirm={handleConfirm}
      valid={valid}
      error={!!error}
      width="400px"
    >
      <React.Fragment>
        <Autocomplete
          options={positions}
          getOptionLabel={(option: Position) => option.positionName}
          value={positions.find(p => p.id === parentId) || null}
          onChange={(_, value) => setParentId(value ? value.id : null)}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField {...params} label={T({ children: "Parent Position" })} fullWidth />
          )}
          sx={{ mb: 2 }}
        />
        <MDInput
          label={T({ children: "Position Name" })}
          value={positionName}
          onChange={e => setPositionName(e.target.value)}
          fullWidth
          required
          sx={{ mb: 2 }}
        />
        {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
      </React.Fragment>
    </AloveDialog>
  );
};

export default AddEditPositionDialog; 